import React, { useState } from "react";
import { View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { Screen, useApplication } from "../../contexts/ApplicationContext";
import { NavigationButton } from "../buttons/NavigationButton";
import { HomeIcon } from "../icons/HomeIcon";
import { LeaderboardIcon } from "../icons/LeaderboardIcon";
import { MyPicksIcon } from "../icons/MyPicksIcon";
import { GlobalStyles } from "../style/Style";

interface BottomNavigationProps {
    loggedIn: boolean;
}

enum State {
    HOME = "home",
    LEADERBOARD = "leaderboard",
    MY_PICKS = "myPicks",
}

export const BottomNavigation = ({ loggedIn }: BottomNavigationProps): JSX.Element => {
    const { appDispatch, appState } = useApplication();
    const [homeActiveState, setHomeActiveState] = useState<boolean>(appState.currentScreen === Screen.HOME);
    const [leaderboardActiveState, setLeaderboardActiveState] = useState<boolean>(
        appState.currentScreen === Screen.LEADERBOARD,
    );
    const [myPicksActiveState, setMyPicksActiveState] = useState<boolean>(appState.currentScreen === Screen.MY_PICKS); // ! needs to get set when mypicks comes in

    const styles = useDynamicStyles(generateStyles);

    const setState = (state: State) => {
        switch (state) {
            case State.HOME: {
                appDispatch({ type: "showHome" });
                setHomeActiveState(true);
                setLeaderboardActiveState(false);
                setMyPicksActiveState(false);
                break;
            }
            case State.LEADERBOARD: {
                appDispatch({ type: "showLeaderboard" });
                setHomeActiveState(false);
                setLeaderboardActiveState(true);
                setMyPicksActiveState(false);
                break;
            }
            case State.MY_PICKS: {
                appDispatch({ type: "showMyPicks" });
                setHomeActiveState(false);
                setLeaderboardActiveState(false);
                setMyPicksActiveState(true);
                break;
            }
        }
    };

    return (
        <View style={styles.bottomNavigationContainer}>
            <NavigationButton
                buttonText="Home"
                onPress={() => setState(State.HOME)}
                icon={
                    <HomeIcon
                        fill={
                            homeActiveState
                                ? EStyleSheet.value(GlobalStyles.NAVIGATION_ICON_FILL_ACTIVE)
                                : EStyleSheet.value(GlobalStyles.NAVIGATION_ICON_FILL)
                        }
                    />
                }
                isActive={homeActiveState}
            />
            <NavigationButton
                buttonText="Leaderboard"
                onPress={() => setState(State.LEADERBOARD)}
                icon={
                    <LeaderboardIcon
                        fill={
                            leaderboardActiveState
                                ? EStyleSheet.value(GlobalStyles.NAVIGATION_ICON_FILL_ACTIVE)
                                : EStyleSheet.value(GlobalStyles.NAVIGATION_ICON_FILL)
                        }
                    />
                }
                isActive={leaderboardActiveState}
            />
            {loggedIn && (
                <NavigationButton
                    buttonText="My Picks"
                    onPress={() => setState(State.MY_PICKS)}
                    icon={
                        <MyPicksIcon
                            fill={
                                myPicksActiveState
                                    ? EStyleSheet.value(GlobalStyles.NAVIGATION_ICON_FILL_ACTIVE)
                                    : EStyleSheet.value(GlobalStyles.NAVIGATION_ICON_FILL)
                            }
                        />
                    }
                    isActive={myPicksActiveState}
                />
            )}
        </View>
    );
};
export default BottomNavigation;

const generateStyles = () => {
    return EStyleSheet.create({
        bottomNavigationContainer: {
            height: 50,
            display: "flex",
            flexDirection: "row",
            backgroundColor: () => EStyleSheet.value(GlobalStyles.NAVIGATION_BACKGROUND),
        },
    });
};
